import { createSelector } from "reselect";
import { getCatalogueTree } from "common/selectors/getCatalogueTree";
import { TreeItem } from "common/types";
import { disableRoots } from "common/data/treeUtils";

export const getTaxesProductTree = createSelector(getCatalogueTree, (productTree): TreeItem[] =>
    disableRoots(productTree)
);
